import { apiClient } from "../config";

async function disconnectProtocol(id: any) {
  const url = `/admin/protocols/${id}/disconnect-program-form`;
  const res = await apiClient.put(url, {id});
  return res.data;
}

export default disconnectProtocol;
